import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LandingLayout from '../components/Landing/LandingLayout';
import LandingHero from '../components/Landing/LandingHero';
import LandingSocialProof from '../components/Landing/LandingSocialProof';
import LandingFeatureGrid from '../components/Landing/LandingFeatureGrid';
import LandingMapRoutesShowcase from '../components/Landing/LandingMapRoutesShowcase';
import LandingRiskShowcase from '../components/Landing/LandingRiskShowcase';
import LandingGlobalRiskShowcase from '../components/Landing/LandingGlobalRiskShowcase';
import LandingWorkflowSection from '../components/Landing/LandingWorkflowSection';
import LandingProductPreview from '../components/Landing/LandingProductPreview';
import LandingCTA from '../components/Landing/LandingCTA';
import LandingFooter from '../components/Landing/LandingFooter';

export default function Landing() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <LandingLayout>
      <LandingHero />
      <LandingSocialProof />
      <LandingFeatureGrid />
      <LandingMapRoutesShowcase />
      <LandingRiskShowcase />
      <LandingGlobalRiskShowcase />
      <LandingWorkflowSection />
      <LandingProductPreview />
      <LandingCTA />
      <LandingFooter />
    </LandingLayout>
  );
}
